/* ------------------- Constants ------------------- */
import LoaderDialog from "@memorang/ui/components/LoaderDialog";
import { messagesSession } from "./constants";

const CreateSessionLoader = () => (
	<LoaderDialog visible messages={messagesSession} />
);

export default CreateSessionLoader;
